module.exports = function() {
  return new Worker(__webpack_public_path__ + "dataParse.worker.be0c757e.worker.js");
};